import { AUTH_REQUEST, AUTH_REGISTER, AUTH_ERROR, AUTH_LOGOUT, AUTH_SUCCESS } from "../../constants";

const mutations = {
	[AUTH_REQUEST]: (state) => {
		state.status = "loading";
	},
	[AUTH_REGISTER]: (state) => {
		state.status = "loading";
	},
	[AUTH_SUCCESS]: (state, data) => {
		state.status = "success";
		state.token = data.token;
		state.userId = data.userId;
	},
	[AUTH_ERROR]: (state) => {
		state.status = "error";
	},
	[AUTH_LOGOUT]: (state) => {
		state.token = null;
		state.status = "";
	},
};

export default mutations;
